import {deserialize, deserializeAs} from 'libs/cerialize';

export class CardScreenModel {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}